// src/components/store/StoreFAQSection.tsx
"use client";

import FaqSectionRenderer from "./sections/faqs";

export default function StoreFAQSection(props: any) {
  return <FaqSectionRenderer {...props} />;
}
export * from "./sections/faqs";
